import React, { useEffect, useState } from "react"
import { MDBDataTable } from "mdbreact"
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormGroup,
  Input,
  Label,
} from "reactstrap"
import API from "../../api/axios"
import moment from "moment"
import { FaRegEyeSlash } from "react-icons/fa6"
import { useNavigate } from "react-router-dom"
import { setBreadcrumbItems } from "../../store/actions"
import { connect } from "react-redux"
const TodaysAppointments = props => {
  // Appointments for today
  const [appointments, setAppointments] = useState([])

  // Doctors list only used by admin
  const [doctors, setDoctors] = useState([])

  // Currently selected doctor from dropdown
  const [selectedDoctorId, setSelectedDoctorId] = useState("")
  const [selectedDoctorName, setSelectedDoctorName] = useState("")

  // Logged-in user's role (admin, doctor, or staff)
  const [userRole, setUserRole] = useState(null)
  const [selectedDate, setSelectedDate] = useState(
    moment().format("YYYY-MM-DD"),
  )

  const navigate = useNavigate()
  const handleEditClick = app => {
    console.log("appointment details", app)
    navigate(`/appointment-details/${app.id}`, {
      state: { appointmentData: app },
    })
  }

  useEffect(() => {
    const role = localStorage.getItem("userRoles")?.trim()
    setUserRole(role)
    if (role === "doctor") {
      const fname = localStorage.getItem("fname") || ""
      const lname = localStorage.getItem("lname") || ""
      setSelectedDoctorName(`${fname} ${lname}`)
    }
  }, [])

  // When role is admin, fetch the doctors list
  useEffect(() => {
    if (userRole === "admin"|| userRole==="staff") {
      fetchDoctors()
    }
  }, [userRole])

  useEffect(() => {
    // Only fetch when we have userRole
    if (
      userRole &&
      (userRole === "doctor" || userRole === "staff" || selectedDoctorId)
    ) {
      fetchAppointments()
    }
  }, [userRole, selectedDoctorId, selectedDate])

  // Fetch list of active doctors
  const fetchDoctors = async () => {
    const authToken = localStorage.getItem("authToken")
    try {
      const res = await API.get(
        "/doctorAvailibility/active-doctors",
        {
          headers: { Authorization: `Bearer ${authToken}` },
        },
      )
      const doctorList = res.data
      setDoctors(doctorList)

      if (doctorList.length > 0) {
        const firstDoctorId = doctorList[0].id
        setSelectedDoctorId(firstDoctorId)
        fetchAppointments(firstDoctorId)
      }
    } catch (err) {
      console.error("Error fetching doctors", err.message)
    }
  }

  const fetchAppointments = async (doctorId = selectedDoctorId) => {
    const authToken = localStorage.getItem("authToken")
    let url = `/appointments?date=${selectedDate}`

    if ((userRole === "admin"|| userRole==="staff" )&& doctorId) {
      url += `&doctorId=${doctorId}`
    }
    try {
      const res = await API.get(url, {
        headers: { Authorization: `Bearer ${authToken}` },
      })
      console.log("doctor appointment", res.data)

      setAppointments(res.data)
      props.setBreadcrumbItems("Appointment Table", breadcrumbItems)
    } catch (err) {
      console.error("Error fetching today's appointments", err)
    }
  }

  const breadcrumbItems = [
    { title: "Dashboard", link: "/dashboard" },
    { title: "Appointment", link: "#" },
  ]

  // Table configuration
  const tableDataConfig = {
    columns: [
      { label: "Patient Name", field: "patientName", sort: "asc" },
      { label: "Start Time", field: "startTime", sort: "asc" },
      { label: "Status", field: "status", sort: "asc" },
      // { label: "Created By", field: "createdBy", sort: "asc" },
      { label: "Action", field: "action", sort: "disabled", width: 100 },
    ],
    rows: appointments.map(app => ({
      patientName: `${app.Patient?.fname} ${app.Patient?.lname}`,
      startTime: moment(app.appointmentStartTime).format("hh:mm A"),
      status: app.StatusList?.name || "N/A",
      // createdBy: `${app.CreatedByUser?.fname} ${app.CreatedByUser?.lname}`,
      action: (
        <button
          className="btn btn-success"
          onClick={() => handleEditClick(app)}
        >
          <FaRegEyeSlash size={20} className="text-green-600" />
        </button>
      ),
    })),
  }

  return (
    <Row>
      <Col className="col-12">
        <Card>
          <CardBody>
            <CardTitle className="h4 mb-4">
              {selectedDoctorName
                ? `${selectedDoctorName}`
                : "Today's Appointments"}
            </CardTitle>

            {(userRole === "admin" || userRole==="staff") && (
              <FormGroup>
                <Label for="doctorSelect">Select Doctor</Label>
                <Input
                  type="select"
                  id="doctorSelect"
                  value={selectedDoctorId}
                  onChange={e => {
                    const doctorId = e.target.value
                    setSelectedDoctorId(doctorId)
                    const selectedDoc = doctors.find(
                      doc => doc.id.toString() === doctorId,
                    )
                    if (selectedDoc) {
                      setSelectedDoctorName(
                        `${selectedDoc.fname} ${selectedDoc.lname}`,
                      )
                    }
                    fetchAppointments(e.target.value)
                    console.log("selected doctorId:", e.target.value)
                  }}
                >
                  {/* <option value="">-- All Doctors --</option> */}
                  {doctors.map(doc => {
                    return (
                      <option key={doc.id} value={doc.id}>
                        {doc.fname} {doc.lname}
                      </option>
                    )
                  })}
                </Input>
              </FormGroup>
            )}
            <div className="d-flex align-items-center gap-3 mb-3">
              {/* <button className=" btn btn-dark">previous</button> */}
              <button
                className="btn btn-primary"
                onClick={() => setSelectedDate(moment().format("YYYY-MM-DD"))}
              >
                today
              </button>

              <button
                className="btn btn-secondary"
                onClick={() =>
                  setSelectedDate(prev =>
                    moment(prev).subtract(1, "days").format("YYYY-MM-DD"),
                  )
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                  />
                </svg>
              </button>
              <button
                className="btn btn-secondary"
                onClick={() =>
                  setSelectedDate(prev =>
                    moment(prev).add(1, "days").format("YYYY-MM-DD"),
                  )
                }
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-right"
                  viewBox="32 32"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </button>
              <span className="ms-3 fw-bold text-primary">
                {moment(selectedDate).format("dddd, MMM DD")}
              </span>
            </div>
            <MDBDataTable responsive bordered data={tableDataConfig} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  )
}

export default connect(null, { setBreadcrumbItems })(TodaysAppointments)
